
const estadosCivil = [
  { id: 'SO', nome: 'Solteiro' },
  { id: 'CA', nome: 'Casado' },
  { id: 'DI', nome: 'Divorciado' },
  { id: 'SE', nome: 'Separado' },
  { id: 'VI', nome: 'Viúvo' }
]

export default estadosCivil



// WEBPACK FOOTER //
// ./src/vuex/cache/estadosCivil.js